import Autocomplete from '@mui/material/Autocomplete';
import { TextField, CircularProgress } from 'components/ui';

const OptionableAutocomplete = ({
  id,
  label,
  options,
  name,
  onChange,
  onSearch,
  onBlur,
  value,
  loading,
  error,
  helperText,
  loadingText,
  noOptionsText,
  disabled,
  autoFocus,
}) => {
  const availableOptions = () => {
    if (value && !options.find((option) => option.value === value.value)) {
      return [value, ...options];
    } else {
      return options;
    }
  };

  return (
    <Autocomplete
      disabled={disabled}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      getOptionLabel={(option) => option.label}
      value={value}
      onChange={(_evt, value) => {
        const evt_value = value ? value.value : null;
        let evt = {
          target: {
            name: name,
            value: evt_value,
            id: id,
          },
        };
        onChange(evt, value);
      }}
      onBlur={onBlur}
      loadingText={loadingText}
      noOptionsText={noOptionsText}
      options={availableOptions()}
      onInputChange={(_e, v) => {
        onSearch(v);
      }}
      loading={loading}
      renderInput={(params) => (
        <TextField
          margin="dense"
          {...params}
          autoFocus={autoFocus}
          label={label}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default OptionableAutocomplete;
